import ProductPlacement from '../product-placement';

export default class WindowStickerPlacement extends ProductPlacement {
  placementFloor?: string;

  workHeight?: number;

  inside?: boolean;

  wet?: boolean;

  individualWindowDamage?: boolean;

  individualExtraInfoWindowDamage?: string;

  timeDesigner?: number;

  timePlacement?: number;

  windowObstacle?: boolean;

  extraInfoWindowObstacle?: string;

  oldStickerPresent?: boolean;

  extraInfoOldStickerPresent?: string;

  alignment?: string;

  visibleDamage?: boolean;

  extraInfoVisibleDamage?: string;

  constructor() {
    super();
  }
}
